import { render, staticRenderFns } from "./PaymentFailedModalComponent.vue?vue&type=template&id=23f456e5&"
import script from "./PaymentFailedModalComponent.vue?vue&type=script&lang=ts&"
export * from "./PaymentFailedModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports